/* eslint-disable @typescript-eslint/ban-types */
import fireEvent from 'react-app-events/lib/fireEvent'
import getErrorMessage from '@helpers/misc/getErrorMessage'
import {EVENTS, sendPosthogData} from '@helpers/posthog'

import makePayment from './makePayment'
import mutation from './mutation'

export interface CreateOrderOpts {
  mutate: Function
  history: {
    push: Function
    replace: Function
  }
  options: any
  setErrorMessage: Function
  setVerifyPhone: Function
  setCreateCard: Function
  regenerateIdempotencyKey: Function
  setCVC?: Function
  paymentData?: any
}

export default async function createOrder({
  mutate,
  history,
  options,
  setErrorMessage,
  setVerifyPhone,
  setCreateCard,
  setCVC,
  regenerateIdempotencyKey,
  paymentData
}: CreateOrderOpts) {
  try {
    const {order} = await mutate({
      mutation,
      variables: {...options, paymentData}
    })
    await makePayment(order, history)

    sendPosthogData(EVENTS.pay.passValidations, {...order})

    return order
  } catch (error) {
    const [graphQLErrors] = error && error.graphQLErrors ? error.graphQLErrors : []
    sendPosthogData(EVENTS.pay.failed, {...graphQLErrors})

    if (error.graphQLErrors && regenerateIdempotencyKey) {
      regenerateIdempotencyKey()
    }

    if (graphQLErrors && graphQLErrors.validationErrors) {
      const {validationErrors} = graphQLErrors
      if (validationErrors.paymentType === 'required') {
        setErrorMessage('Por favor selecciona un medio de pago')
      } else if (validationErrors.cardId === 'required') {
        setCreateCard(true)
      } else if (validationErrors.cardId === 'cardIncompatibleWithCoupon') {
        setErrorMessage('Tarjeta de crédito no compatible con descuento')
      } else if (validationErrors.cvc === 'required') {
        setCVC(true)
      } else if (validationErrors.cashAmount === 'required') {
        setErrorMessage('Por favor dinos con cuanto vas a pagar para llevar vuelto')
      } else if (
        validationErrors.nationalId === 'required' ||
        validationErrors.nationalId === 'invalid'
      ) {
        setErrorMessage(`El número de identificación nacional ingresado es inválido`)
      } else if (validationErrors.phone === 'required') {
        setErrorMessage(
          'Por favor escribe tu teléfono, es necesario para llamarte si tenemos dudas'
        )
      } else if (validationErrors.phone === 'requireVerification') {
        setVerifyPhone({single: false})
      } else if (validationErrors.phone === 'requireSingleUseVerification') {
        setVerifyPhone({single: true, verificationId: validationErrors.verificationId})
      } else if (validationErrors.fraud === 'retry') {
        fireEvent('suggestPaymentChange', validationErrors)
        setErrorMessage(validationErrors.clientMessage)
      } else if (
        Object.keys(validationErrors).find(errorKey => errorKey.startsWith('orderParams'))
      ) {
        fireEvent('orderParamsError', validationErrors)
      } else if (validationErrors.orderGroupId === 'closed') {
        setErrorMessage(validationErrors.message)
      }
    } else {
      fireEvent('createOrderError', error)
      setErrorMessage(getErrorMessage(error))
    }
  }
}
